import script from "./DatosPaciente.vue?vue&type=script&setup=true&lang=js"
export * from "./DatosPaciente.vue?vue&type=script&setup=true&lang=js"

import "./DatosPaciente.vue?vue&type=style&index=0&id=13743613&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13743613"]])

export default __exports__